import React from 'react';
import { Icon, Text } from '@goodfynd/ui';
import type { IconName } from '@goodfynd/ui';

import {
  StyledBenefitContainer,
  StyledBenefitsContainer,
  StyledContainer,
  StyledGraphicContainer,
  StyledImage,
} from './styles';
import type { CmsBenefitsProps } from './types';

export default function CmsBenefits({
  className,
  benefits = [],
  header,
  ...props
}: CmsBenefitsProps) {
  return (
    <StyledContainer {...props} className={className}>
      {!!header && (
        <Text as="heading5" style={{ marginBottom: 24 }}>
          {header}
        </Text>
      )}

      <StyledBenefitsContainer {...props}>
        {benefits.map(({ description, icon, image }) => (
          <StyledBenefitContainer key={icon}>
            {(!!icon || !!image) && (
              <StyledGraphicContainer>
                {!!icon && (
                  <Icon
                    color="TextIconFavorable"
                    name={icon.replace('icon-', '').trim() as IconName}
                    size={24}
                  />
                )}
                {!!image && (
                  <StyledImage
                    alt={header ?? ''}
                    height={24}
                    src={image}
                    width={24}
                  />
                )}
              </StyledGraphicContainer>
            )}

            <Text>{description}</Text>
          </StyledBenefitContainer>
        ))}
      </StyledBenefitsContainer>
    </StyledContainer>
  );
}
